export default __webpack_public_path__ + "static/media/dimg3.9de39404.jpg";